<script setup>
import {computed} from "vue";

const emit = defineEmits(['selected'])
const props = defineProps({
    step: {
        type: Object,
        required: true
    },
    first: {
        type: Boolean,
        required: false,
        default: false
    },
    last: {
        type: Boolean,
        required: false,
        default: false
    },
    stepBackgroundClass: {
        type: String,
        required: true,
    },
    activeClass: {
        type: String,
        required: false,
        default: 'border-wlPrimary bg-myflowLavender'
    },
    activeRingClass: {
        type: String,
        required: false,
        default: 'border-wlPrimary'
    },
    completedClass: {
        type: String,
        required: false,
        default: 'text-wlPrimary'
    },
    lockedClass: {
        type: String,
        required: false,
        default: 'border-gray-200'
    },
    unlockedClass: {
        type: String,
        required: false,
        default: 'border-wlPrimary'
    },
    isCompleted: {
        type: Boolean,
        required: false,
        default: false
    },
    isActive: {
        type: Boolean,
        required: false,
        default: false
    },
    hasWarning: {
        type: Boolean,
        required: false,
        default: false
    },
    tooltip: {
        type: String,
        required: false,
        default: null
    }
})

const isUnlocked = computed(() => {
    if (props.step.unlocked) {
        return true
    }
})

</script>

<template>
    <div
        class="flex flex-col items-center relative group"
        :class="[isUnlocked ? isActive ? 'step-is-unlocked-and-active' : 'step-is-unlocked-but-not-active' : 'step-is-locked']"
        @click.prevent="emit('selected')"
    >
        <div
            class="border-4 rounded-full cursor-pointer"
            :class="stepBackgroundClass"
        >
            <div
                class="w-5 h-5 border rounded-full relative"
                :class="[isActive ? activeClass : '', isUnlocked ? unlockedClass : lockedClass]"
            >
                <div
                    v-if="isActive"
                    class="absolute -inset-1.5 rounded-full border-2"
                    :class="activeRingClass"
                ></div>
                <i
                    v-if="! isUnlocked"
                   class="fa-solid fa-lock absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-xxs text-gray-400"
                ></i>
                <span
                    v-if="isUnlocked && hasWarning"
                    class="w-4 h-4 absolute bg-yellow-200 border border-yellow-400 -left-2.5 -top-2.5 rounded-wl flex items-center justify-center"
                >
                    <i
                       class="fa-regular fa-exclamation text-xxs text-black"
                    ></i>
                </span>

                <span
                    v-if="isCompleted"
                    :class="completedClass"
                    class="absolute inset-0 rounded-wl"
                >
                    <i
                        class="fa-solid fa-check absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-xs"
                    ></i>
                </span>
            </div>
        </div>
        <span
            class="absolute top-full"
            :class="first ? 'left-0' : last ? 'right-0' : ''"
        >
            <a
                class="flex items-center pt-1 text-center text-myflowText overflow-hidden overflow-ellipsis text-xxs cursor-default"
            >
                <i v-if="step.icon" :class="step.icon"></i>
                <span class="whitespace-nowrap">{{ step.localizetitle ? _mft(step.title) : step.title }}</span>
            </a>
        </span>
        <div
            v-if="tooltip"
            class="hidden group-hover:block absolute top-full mt-5 w-32 text-center text-xxs text-white bg-black/80 rounded px-2 py-1"
            :class="first ? 'left-0' : last ? 'right-0' : ''"
        >
            {{ tooltip }}
        </div>
    </div>
</template>

<style scoped>

</style>
